import React from 'react'


const ToastContext = React.createContext({ value: {}, setValue: () => { }, handleClose: () => { } });

export default ToastContext;